import { render } from "./HomePage.vue?vue&type=template&id=1348634a&scoped=true&ts=true&lang=pug"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=1348634a&scoped=true&lang=css"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/PWA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1348634a"]])

export default __exports__